export const LineLoader = () => {
  return (
    <div className="w-full h-[1.2vh] relative">
      <div className="dark:w-0 dark:h-0 w-full custom-pulse-light h-[1.2vh] left-0 top-0 absolute bg-neutral-700 rounded-[2vh]" />
      <div className="w-0 h-0 dark:w-full custom-pulse-dark dark:h-[1.2vh] left-0 top-0 absolute bg-neutral-700 rounded-[2vh]" />
    </div>
  );
};
